export class LocalStorage {
	//
	static getItem = (name = '') => {
		if (!name) return null;
		const item = localStorage.getItem(name);
		return item ? JSON.parse(item) : null;
	};

	static setItem = (item = null) => {
		if (!item) return;
		return localStorage.setItem(JSON.stringify(item));
	};

	static deleteItem = (name = '') => {
		if (!name) return null;
		return localStorage.deleteItem(name);
	};
}
